import { useEffect, useState } from 'react';
import { getAdminConsents } from '../../lib/api';

const CONTEXT_LABELS = {
  checkout: 'Pedido web',
  transfer_proof: 'Comprobante de transferencia',
  marketing_opt_in: 'Alta de promociones',
  review: 'Reseña',
  wa_first_message: 'Aviso por WhatsApp',
};

function fmt(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso || '');
  return `${d.toLocaleString('es-MX', { timeZone: 'America/Mexico_City' })} (hora CDMX)`;
}

const yn = (v) => (v === true ? 'sí' : v === false ? 'no' : '—');

/** Panel: consentimientos registrados para un pedido (colección consents, paquete legal v2026-10-09). */
export default function OrderConsentInfo({ order }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!order?.id) return undefined;
    let alive = true;
    const checkoutId = order.checkout_id || order.mercadopago_checkout_id || '';
    Promise.all([
      getAdminConsents({ order_id: order.id }).catch(() => ({ consents: [] })),
      checkoutId ? getAdminConsents({ checkout_id: checkoutId }).catch(() => ({ consents: [] })) : { consents: [] },
    ]).then(([a, b]) => {
      if (!alive) return;
      const seen = new Set();
      const all = [...(a.consents || []), ...(b.consents || [])].filter((c) => !seen.has(c.id) && seen.add(c.id));
      setRows(all);
    });
    return () => {
      alive = false;
    };
  }, [order?.id, order?.checkout_id, order?.mercadopago_checkout_id]);

  if (!order?.id || rows === null) return null;

  return (
    <div className="mt-3 rounded-md border p-2 text-xs text-muted-foreground space-y-1" data-testid="order-consent-info">
      <p className="font-semibold text-foreground">Consentimientos</p>
      {rows.length === 0 ? (
        <p>Sin registro (pedido por WhatsApp, mostrador o anterior al 9 oct 2026).</p>
      ) : (
        rows.map((c) => {
          const cb = c.checkboxes || {};
          return (
            <p key={c.id}>
              {CONTEXT_LABELS[c.context] || c.context} · {fmt(c.at)} · versión {c.notice_version || '—'} · aviso/términos{' '}
              {yn(cb.accept_privacy_terms)} · promociones {yn(cb.marketing_whatsapp)} · cobro anticipado{' '}
              {yn(cb.prepayment_authorized)}
              {cb.transfer_proof_consent != null ? ` · comprobante ${yn(cb.transfer_proof_consent)}` : ''}
            </p>
          );
        })
      )}
    </div>
  );
}
